import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import InstitutionSearch from './pages/InstitutionSearch';
import InstitutionDetail from './pages/InstitutionDetail';
import BlastRadius from './pages/BlastRadius';
import OwnershipTree from './pages/OwnershipTree';
import Status from './pages/Status';
import Login from './pages/Login';
import NotFound from './pages/NotFound';

function LoadingScreen() {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
        <p className="mt-4 text-gray-600">Loading...</p>
      </div>
    </div>
  );
}

function AppRoutes() {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return <LoadingScreen />;
  }

  if (!isAuthenticated) {
    return <Login />;
  }

  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Dashboard />} />
        <Route path="search" element={<InstitutionSearch />} />
        <Route path="institution/:lei" element={<InstitutionDetail />} />
        <Route path="blast-radius/:lei" element={<BlastRadius />} />
        <Route path="ownership/:lei" element={<OwnershipTree />} />
        <Route path="status" element={<Status />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
